/* Vereecke Recup Yellow — minimal vanilla JS for nav, gallery, lightbox, reveal */
(function () {
  "use strict";

  // ===== Header scroll state =====
  var header = document.querySelector(".header");
  if (header) {
    var setScrolled = function () {
      if (window.scrollY > 50) header.classList.add("scrolled");
      else header.classList.remove("scrolled");
    };
    setScrolled();
    window.addEventListener("scroll", setScrolled, { passive: true });
  }

  // ===== Mobile menu toggle =====
  var hamburger = document.querySelector(".hamburger");
  var mobile = document.querySelector(".mobile-menu");
  if (hamburger && mobile) {
    hamburger.addEventListener("click", function () {
      hamburger.classList.toggle("open");
      mobile.classList.toggle("open");
      document.body.style.overflow = mobile.classList.contains("open") ? "hidden" : "";
    });
    mobile.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () {
        hamburger.classList.remove("open");
        mobile.classList.remove("open");
        document.body.style.overflow = "";
      });
    });
  }

  // ===== Reveal on scroll (IntersectionObserver) =====
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add("is-visible");
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: "0px 0px -10% 0px", threshold: 0.05 });
    document.querySelectorAll(".reveal").forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll(".reveal").forEach(function (el) { el.classList.add("is-visible"); });
  }

  // ===== Product gallery =====
  var gallery = document.querySelector("[data-gallery]");
  if (gallery) {
    var main = gallery.querySelector("[data-gallery-main]");
    var thumbs = gallery.querySelectorAll("[data-gallery-thumb]");
    var prevBtn = gallery.querySelector("[data-gallery-prev]");
    var nextBtn = gallery.querySelector("[data-gallery-next]");
    var idx = 0;
    var srcs = [];
    thumbs.forEach(function (t, i) {
      srcs.push(t.getAttribute("data-src"));
      t.addEventListener("click", function () { setIdx(i); });
    });

    function setIdx(i) {
      idx = (i + srcs.length) % srcs.length;
      if (main) main.querySelector("img").setAttribute("src", srcs[idx]);
      thumbs.forEach(function (t, j) {
        t.classList.toggle("active", j === idx);
      });
    }
    if (prevBtn) prevBtn.addEventListener("click", function () { setIdx(idx - 1); });
    if (nextBtn) nextBtn.addEventListener("click", function () { setIdx(idx + 1); });

    // Lightbox
    var lb = document.querySelector("[data-lightbox]");
    if (main && lb) {
      var lbImg = lb.querySelector("img");
      var lbClose = lb.querySelector("[data-lightbox-close]");
      var lbPrev = lb.querySelector("[data-lightbox-prev]");
      var lbNext = lb.querySelector("[data-lightbox-next]");
      main.addEventListener("click", function () {
        lbImg.setAttribute("src", srcs[idx]);
        lb.classList.add("open");
        document.body.style.overflow = "hidden";
      });
      function closeLb() { lb.classList.remove("open"); document.body.style.overflow = ""; }
      if (lbClose) lbClose.addEventListener("click", closeLb);
      lb.addEventListener("click", function (e) { if (e.target === lb) closeLb(); });
      if (lbPrev) lbPrev.addEventListener("click", function () { setIdx(idx - 1); lbImg.setAttribute("src", srcs[idx]); });
      if (lbNext) lbNext.addEventListener("click", function () { setIdx(idx + 1); lbImg.setAttribute("src", srcs[idx]); });
      document.addEventListener("keydown", function (e) {
        if (!lb.classList.contains("open")) return;
        if (e.key === "Escape") closeLb();
        if (e.key === "ArrowLeft") { setIdx(idx - 1); lbImg.setAttribute("src", srcs[idx]); }
        if (e.key === "ArrowRight") { setIdx(idx + 1); lbImg.setAttribute("src", srcs[idx]); }
      });
    }
  }

  // ===== Animated counters (visible-once) =====
  if ("IntersectionObserver" in window) {
    var counters = document.querySelectorAll("[data-counter]");
    var co = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var from = parseFloat(el.getAttribute("data-from") || "0");
        var to = parseFloat(el.getAttribute("data-to") || "0");
        var suffix = el.getAttribute("data-suffix") || "";
        var dur = 1500;
        var start = null;
        function step(ts) {
          if (start === null) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var ease = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(from + (to - from) * ease) + suffix;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
        co.unobserve(el);
      });
    }, { threshold: 0.5 });
    counters.forEach(function (c) { co.observe(c); });
  }
})();

// ── BTW PRICE TOGGLE (PDP) ──
(function () {
  var priceEl = document.querySelector('[data-price-toggle]');
  var btns = document.querySelectorAll('.pdp2__btw-btn');
  if (!priceEl || !btns.length) return;
  var excl = priceEl.getAttribute('data-excl');
  var incl = priceEl.getAttribute('data-incl');
  btns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var mode = btn.getAttribute('data-mode');
      priceEl.textContent = mode === 'incl' ? incl : excl;
      btns.forEach(function (b) {
        var active = b === btn;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    });
  });
})();
